import styled from 'styled-components';
import { StockModelCardHeaderStyled } from '../StockModelCardHeaderStyled';
import { rem } from 'polished';

export const StockModelCardHeaderStyledOV = styled(StockModelCardHeaderStyled)`
    .stockModelCard-header--engineInfo {
        font-size: ${rem('14px')};
        color: ${({ theme }) => theme.colors.grey22};
    }
    .stockModelCard-header {
        &--heading {
            color: ${({ theme }) => theme.colors.black};
            font-size: ${rem('21px')};
            line-height: ${rem('23px')};
            font-weight: normal;
            text-transform: uppercase;
            font-family: ${({ theme }) => theme.fonts.fontBase};
        }
        &--engineInfo {
            margin-top: ${rem(8)};
        }
        &--demoInfo {
            color: ${({ theme }) => theme.colors.grey22};
            font-size: ${({ theme }) => theme.fontSizes.h5};
        }
    }
`;
